import { type ValidationError } from '@adv-frontend/form-kit';
import { pluralize } from '../../../string';

export const MIN_LENGTH_ERROR_CODE = 'MIN_LENGTH_ERROR';

type MinLengthErrorParams = {
    minLength: number;
};

export type MinLengthValidationError = ValidationError<typeof MIN_LENGTH_ERROR_CODE, MinLengthErrorParams>;

export const MIN_LENGTH_ERROR_MESSAGE = ({ minLength }: MinLengthErrorParams) =>
    `Необходимо минимум ${pluralize(minLength, `%d символ`, `%d символа`, `%d символов`)}`;
